/**
 * Profile Service - User profile and settings operations
 */

import { supabase } from '../../supabaseClient';
import { transformProfileFromDB, transformProfileToDB } from '../utils/transformers';

/**
 * Fetch current user's profile
 */
export async function fetch() {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No authenticated user');

    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', user.id)
      .single();

    if (error) throw error;

    return {
      success: true,
      data: transformProfileFromDB(data)
    };
  } catch (error) {
    console.error('[profileService.fetch] Error:', error);
    return {
      success: false,
      error: error.message
    };
  }
}

/**
 * Update user settings
 */
export async function updateSettings(settings) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No authenticated user');

    const { data, error } = await supabase
      .from('profiles')
      .update(transformProfileToDB(settings))
      .eq('id', user.id)
      .select()
      .single();

    if (error) throw error;

    return {
      success: true,
      data: transformProfileFromDB(data)
    };
  } catch (error) {
    console.error('[profileService.updateSettings] Error:', error);
    return {
      success: false,
      error: error.message
    };
  }
}

export const profileService = {
  fetch,
  updateSettings
};
